import { useState, useEffect } from 'react';
import { Modal, Button, Form, Spinner } from 'react-bootstrap';
import { updateAnswer, createAnswer } from '../service/brc';
import { useFormValidation, Validations } from '../service/formHelper';
import { AlertDismissable } from './Alerts';

const initialValues = {
  answer: '',
  isCorrect: false,
};

const validationRules = {
  answer: [
    (value) => Validations.isEmpty(value, 'Answer cannot be empty'),
  ],
};

const AnswerForm = (props) => {
  const [isLoading, setLoading] = useState(false);
  const [showAlert, setAlert] = useState(false);
  const [isError, setError] = useState(false);
  const [message, setMessage] = useState('Unknown Error!');
  const { values, errors, setValues, handleChange, handleSubmit } = useFormValidation(
    initialValues,
    validationRules
  );

  useEffect(() => {
    if (props.show) {
      setValues(props);
    }
  }, [props, setValues]);


  const dismissAlert = () => setAlert(false);

  const onSubmit = async (formData) => {
    setLoading(true);
    let reqData = {
      ...formData,
      questionId: props.questionId,
      count: props.isEdit? null: 0,
      exposedCount: props.isEdit? null: 0,
      controlCount: props.isEdit? null: 0,
      email: props.sessionUser.email,
    };
    createUpdate(reqData);
  },
  createUpdate = async (reqData) => {
    let response = {};
    if (props.isEdit) {
      response = await updateAnswer(reqData, props.id);
    } else {
      response = await createAnswer(reqData);
    }
    if (response && response.data) {
      if (response.data._status === true) {
        setError(false);
        setMessage(response.data._message);
        setAlert(true);
        handleClose();
        props.loadAnswers();
      } else {
        setError(true);
        setMessage(response.data._message);
        setAlert(true);
      }
      setLoading(false);
    }
  },
  handleClose = () => {
    dismissAlert();
    props.setShow(false);
  };

  return (
    <Modal show={props.show} onHide={handleClose} backdrop='static' keyboard={false}>
      <Modal.Header closeButton closeLabel='' style={{ borderRadius: 5 }}>
        {props.isEdit && <Modal.Title>Edit Answer</Modal.Title>}
        {!props.isEdit && <Modal.Title>Create Answer</Modal.Title>}
      </Modal.Header>
      <Modal.Body>
        <AlertDismissable dismiss={dismissAlert} show={showAlert} message={message} type={isError ? 'error' : 'success'} />
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Form.Group className='mb-3' controlId='question'>
            <Form.Label>Answer</Form.Label>
            <Form.Control
              required
              as='textarea'
              rows={3}
              name='answer'
              value={values.answer}
              isInvalid={!!errors.answer}
              onChange={handleChange}
            />
            <Form.Control.Feedback type="invalid">{errors?.answer}</Form.Control.Feedback>
          </Form.Group>
          <Form.Group className='mb-3' controlId='isCorrect'>
            <Form.Label>Preferred Answer</Form.Label>
            <Form.Check
              type='checkbox'
              id='isCorrect'
              name="isCorrect"
              checked={values.isCorrect}
              onChange={handleChange}
            />
          </Form.Group>
          <Button variant='primary' type='submit'>
            Submit
          </Button>
        </Form>
      </Modal.Body>
      {isLoading && (
        <div
          style={{
            position: 'absolute',
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            zIndex: 999,
            backgroundColor: '#000000c4',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}>
          <Spinner animation='border' variant='primary' />
        </div>
      )}
    </Modal>
  );
};

export default AnswerForm;
